import Vue from 'vue'
import App from './App'
import router from './router'
import { Button, Swipe, SwipeItem, Header, Search, Switch, Popup, Picker, Loadmore, Spinner, DatetimePicker } from 'mint-ui'
import VueResource from 'vue-resource'
import vueTouch from 'vue-touch'
import 'mint-ui/lib/style.css'
import '../static/MUI/css/mui.min.css'
import '../static/MUI/css/icons-extra.css'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import moment from 'moment'
import { getLocation } from './utils/getLocation'
import { VueJsonp } from 'vue-jsonp'
import WechatPlugin from './utils/WechatPlugin'
Vue.use(VueJsonp);
Vue.use(WechatPlugin);



Vue.config.productionTip = false
Vue.component(Button.name, Button)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.component(Header.name, Header)
Vue.component(Search.name, Search)
Vue.component(Switch.name, Switch)
Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)
Vue.component(Loadmore.name, Loadmore)
Vue.component(Spinner.name, Spinner)
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.use(VueDirectiveImagePreviewer)
Vue.use(VueResource)


// Vue.http.options.root = 'https://gather.onbotics.cn/'

Vue.http.options.root = process.env.BASE_URL
Vue.use(vueTouch, { name: 'v-touch' })
vueTouch.config.swipe = {
    threshold: 1
}
// getLocation()
//获取当前位置
// Vue.prototype.getData = function (that, currentPosition, clearInterval) {
//     let data = {
//         key: "5ZMBZ-4OX6J-BELFV-KS2SR-PW6XZ-6NBLT", //申请的密钥
//     };
//     let url = "https://apis.map.qq.com/ws/location/v1/ip"; //这个就是地理位置信息的接口
//     data.output = "jsonp";
//     that
//         .$jsonp(url, data)
//         .then((res) => {
//             if (res.status == 121) {
//                 clearInterval();
//             }
//             var currentPosi = {
//                 longitude: res.result.location.lng,
//                 latitude: res.result.location.lat,
//             };
//             if (currentPosition.length == 0) {
//                 currentPosition.push(currentPosi);
//             } else {
//                 for (var i = 0; i < currentPosition.length; i++) {
//                     if (
//                         JSON.stringify(currentPosition).indexOf(
//                             JSON.stringify(currentPosi)
//                         ) <= -1
//                     ) {
//                         currentPosition.push(currentPosi);
//                     }
//                 }
//             }
//             // console.log(currentPosition);
//         })
//         .catch((error) => {
//             console.log(error);
//         });
// }


Vue.filter('dataForm', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)
})
Vue.config.devtools = true
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js